import type { ReactElement } from 'react';
import Link from 'next/link';
import { Button } from '@/components/ui/button';
import { TwitterIcon } from '@/assets/social/twitter';
import { FacebookIcon } from '@/assets/social/facebook';
import { DiscordIcon } from '@/assets/social/discord';

export default function Social(): ReactElement {
  return (
    <div className="w-fit flex items-center justify-center gap-1.5 sm:gap-3">
      <Link href="https://x.com/solarious_us" target="_blank">
        <Button
          variant="secondary"
          className="w-28 sm:w-32 flex items-center gap-1 sm:gap-1.5 border hover:bg-border/5 p-0"
        >
          <TwitterIcon className="w-5 h-5" />
          <p>Twitter</p>
        </Button>
      </Link>
      <Link href="https://facebook.com/solarious.us" target="_blank">
        <Button
          variant="secondary"
          className="w-28 sm:w-32 flex items-center gap-1 sm:gap-1.5 border hover:bg-border/5 p-0"
        >
          <FacebookIcon className="w-5 h-5" />
          <p>Facebook</p>
        </Button>
      </Link>
      <Link href="https://discord.com/invite/8YVPu6NX" target="_blank">
        <Button
          variant="secondary"
          className="w-28 sm:w-32 flex items-center gap-1 sm:gap-1.5 border hover:bg-border/5 p-0"
        >
          <DiscordIcon className="w-5 h-5" />
          <p>Discord</p>
        </Button>
      </Link>
    </div>
  );
}
